<template>
  <modal
    name="versionRemove"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :width="540"
    :height="264"
  >
    <div class="cantainer">
      <div class="content">
        <span>
          确定删除选中版本吗？删除之后将不可恢复，但不会对当前项目数据造成任何影响。
        </span>
      </div>
      <div class="footer">
        <div
          class="button button--default"
          @click="cancel"
        >取消</div>
        <div
          class="button button--primary"
          @click="confirm"
        >删除</div>
      </div>
      <div
        class="close-btn"
        @click="clickToClose()"
      >
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {

    };
  },
  created () {

  },
  methods: {
    clickToClose () {
      this.$modal.hide('versionRemove');
      this.$bus.emit('versionRemove.close');
    },
    beforeOpen ({ params } = {}) {
    },
    confirm () {
      this.$bus.emit('versionRemove.confirm');
    },
    cancel () {
      this.clickToClose();
    }
  }
}
</script>

<style lang="scss" scoped>
.cantainer {
  position: relative;
  width: 540px;
  height: 264px;
  margin: auto;
  padding: 70px 88px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  margin-bottom: 36px;
  margin-left: 24px;
  margin-right: 24px;
  line-height: 1.8;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  > div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.button {
  width: 160px;
  height: 40px;
  border-radius: 8px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;

  &--primary {
    background-color: #ea3d45;
  }
  &--default {
    background-color: #eaeaf6;
    color: #333;
  }
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/versionRemove.vue